import React, { useState, useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'underscore';
import { withScope, QueryParam } from '@bingads-webui-react/scope-service';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { siteMapPropType, findSelectedNode } from '@bingads-webui-campaign-react/with-site-map';
import { withServerContext } from '@bingads-webui-campaign-react/server-context';
import {
  storeQueries as defaultStoreQueries,
  feedQueries as defaultFeedQueries,
  MmcDataSourceInitializer
} from '@bingads-webui-campaign-react/merchant-shared';
import { SummaryBarFactory } from './components';
import { getMerchantCenterConfig } from './helpers/merchant-center-config';

const MerchantCenterSummaryBar = (props) => {
  const customSummaryBarItemsRef = useRef();
  const [storeName, setStoreName] = useState(null);
  const [feedName, setFeedName] = useState(null);

  const getStateFromProps = useCallback(() => {
    const {
      scope,
      storeQueries,
      feedQueries,
    } = props;
    const { storeId, feedId } = scope.values;

    if (storeId) {
      storeQueries.getStore(storeId, true).then((store) => {
        setStoreName(store.Name);
      });
    }

    if (storeId && feedId) {
      feedQueries.getFeedDetails(storeId, feedId).then((feed) => {
        setFeedName(feed.Name);
      });
    }
  }, [props]);

  useEffect(() => {
    if (customSummaryBarItemsRef && customSummaryBarItemsRef.current) {
      customSummaryBarItemsRef.current.innerText = '';
    }
    getStateFromProps();
  }, [getStateFromProps]);

  const {
    i18n,
    siteMap,
    scope,
  } = props;

  return findSelectedNode(siteMap) ? (
    <React.Fragment>
      <MmcDataSourceInitializer {...props} />
      <SummaryBarFactory
        {...props}
        {...getMerchantCenterConfig({
            i18n,
            storeName,
            feedName,
            siteMap,
            scope,
          })}
      />
    </React.Fragment>
  ) : <MmcDataSourceInitializer {...props} />;
};

MerchantCenterSummaryBar.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  serverContext: PropTypes.shape({
    Token: PropTypes.string.isRequired,
  }).isRequired,
  feedQueries: PropTypes.shape({}),
  storeQueries: PropTypes.shape({}),
  siteMap: siteMapPropType.isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
};

MerchantCenterSummaryBar.defaultProps = {
  storeQueries: defaultStoreQueries,
  feedQueries: defaultFeedQueries,
};

const StyledMerchantCenterSummaryBar = compose(
  withServerContext,
  withI18nConsumer,
  withScope
)(MerchantCenterSummaryBar);

export { StyledMerchantCenterSummaryBar as MerchantCenterSummaryBar };
